import React from 'react'
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Pagination from "react-bootstrap/Pagination";
import { AddSelected, RemoveSelected, SearchIcon, SearchIconWhite } from '../../assets/images';
import { useDataAccessPagination } from '../../CustomHooks/useDataAccessPagination';

const EditModalContainer = ({isDarkTheme,isEditCustomer,selectedEntity,setTopLeftCheck,topLeftCheck,selectAllHandler,searchTextOne,searchHandlerOne,midLeftCheck,setMidLeftCheck}) => {
    const [nextClickOne, prevClickOne, pageCounterOne, currentPageNoOne, limitOne, totalPagesOne, setCurrentPageNoOne, setTotalPagesOne, maxPageAllowedOne, setPageCounterOne] = useDataAccessPagination(10, 1, 10, 1);
    const [nextClickTwo, prevClickTwo, pageCounterTwo, currentPageNoTwo, limitTwo, totalPagesTwo, setCurrentPageNoTwo, setTotalPagesTwo, maxPageAllowedTwo, setPageCounterTwo] = useDataAccessPagination(10, 1, 10, 1);
  return (
    <>
         <Modal 
         show={isEditCustomer}
         centered dialogClassName="selectionModel" backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>
                        <p className="ModelHeaderName">
                            Select {selectedEntity.name}
                            <span className="countNumber">
                                Count : <span>{selectedEntity.totalCount}</span>
                            </span>
                        </p>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <div className="SelectDiv">
                            <div className="TwoSelectionDiv">
                                <div className="SelectAllSearchBarDiv">
                                    <div className="HeaderwithSelectAll">
                                        <p className="HeaderTextLabel">Unselected {selectedEntity.name}</p>
                                        <div>
                                            <input type="checkbox" checked={topLeftCheck} onChange={() => {
                                                                setTopLeftCheck(!topLeftCheck)
                                                                selectAllHandler("e", "ONE")
                                                            }}/>
                                            <p className="AllTextwithValue"
                                            onClick={() => {
                                                setTopLeftCheck(!topLeftCheck)
                                                selectAllHandler("e", "ONE")
                                            }}
                                            >
                                                Select all <span>{selectedEntity.totalCount - selectedEntity.selectedCount}</span>
                                            </p>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="SelectionListWithSelectAll">
                                            <input
                                                className="SearchViewInput1"
                                                type="search"
                                                placeholder={`Search unselected ${selectedEntity.identifier}`}
                                                                value={searchTextOne}
                                                                onChange={(e) => searchHandlerOne(e)}
                                                                disabled={topLeftCheck}
                                                />
                                            {
                                                isDarkTheme ?
                                                    <img src={SearchIcon} alt='search icon' style={{ cursor: 'pointer' }} /> :
                                                    <img src={SearchIconWhite} height="15" alt='search icon' style={{ cursor: 'pointer' }} />
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="MainResultDiv">
                                    <div className="HeaderwithSelectAll">
                                        <p className="HeaderTextLabel">Search Result</p>
                                        <div>
                                            <input type="checkbox"
                                             checked={midLeftCheck}
                                             disabled={topLeftCheck}
                                             onChange={() => {
                                                 setMidLeftCheck(!midLeftCheck)
                                                 selectAllHandler('e', 'ONE')
                                             }}
                                            />
                                            <p className="AllTextwithValue"
                                             onClick={() => {
                                                setMidLeftCheck(!midLeftCheck)
                                                selectAllHandler('e', 'ONE')
                                            }}
                                            >
                                                Select all <span>7</span>
                                            </p>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="SelectionListWithSelectAll">
                                            <input
                                                className="SearchViewInput1"
                                                type="search"
                                            />
                                            {
                                                isDarkTheme ?
                                                    <img src={SearchIcon} alt="Search" style={{ cursor: 'pointer' }} /> :
                                                    <img src={SearchIconWhite} height="15" alt="Search" style={{ cursor: 'pointer' }} />

                                            }
                                        </div>
                                    </div>
                                    <div className="HgtCheckBoxList">
                                        <div>
                                            <div className='dataAccessListItem'>
                                                <input type="checkbox"/>
                                                <p className="AllTextwithValue">
                                                    Select all <span>7</span>
                                                </p>
                                            </div>
                                            {/* {
                                                unselectedTempFiltered.map((item) => (
                                                    <DataAccessListItem isItDisabled={topLeftCheck || midLeftCheck} item={item} key={item.Id} selectItemHandler={selectItemHandler} type="ONE" />
                                                ))
                                            } */}
                                        </div>
                                    </div>
                                    {
                                            <div className="PaginationDiv" style={{ marginBottom: "5px", marginRight: "-6px" }}>
                                                <h5 className='PageNumbers'>
                                                   1
                                                </h5>
                                                <span>of</span>
                                                <h5 className='PageNumbers'>2</h5>
                                                <Pagination>
                                                    <Pagination.Prev />
                                                    <Pagination.Next/>
                                                </Pagination>
                                            </div>
                                    }
                                </div>
                            </div>

                            <div className="AddRemoveBtnDiv">
                                <div className='text-center'>
                                    <Button variant="primary" className="ApplyBtn">
                                        Add <img src={AddSelected} alt='add plus icon' />
                                    </Button>
                                    <Button variant="primary" className="ApplyBtn">
                                        <img src={RemoveSelected} alt='remove arrow' />  Remove
                                    </Button>
                                </div>
                            </div>

                            <div className="TwoSelectionDiv">
                                <div className="SelectAllSearchBarDiv">
                                    <div className="HeaderwithSelectAll">
                                        <p className="HeaderTextLabel">Unselected Customer(s)</p>
                                        <div>
                                            <input type="checkbox"/>
                                            <p className="AllTextwithValue">
                                                Select all <span>7</span>
                                            </p>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="SelectionListWithSelectAll">
                                            <input
                                                className="SearchViewInput1"
                                                type="search"/>
                                            {
                                                isDarkTheme ?
                                                    <img src={SearchIcon} alt='search icon' style={{ cursor: 'pointer' }} /> :
                                                    <img src={SearchIconWhite} height="15" alt='search icon' style={{ cursor: 'pointer' }} />
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="MainResultDiv">
                                    <div className="HeaderwithSelectAll">
                                        <p className="HeaderTextLabel">Search Result</p>
                                        <div>
                                            <input type="checkbox"/>
                                            <p className="AllTextwithValue" >
                                                Select all <span>7</span>
                                            </p>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="SelectionListWithSelectAll">
                                            <input
                                                className="SearchViewInput1"
                                                type="search"
                                            />
                                            {
                                                isDarkTheme ?
                                                    <img src={SearchIcon} alt="Search" style={{ cursor: 'pointer' }} /> :
                                                    <img src={SearchIconWhite} height="15" alt="Search" style={{ cursor: 'pointer' }} />

                                            }
                                        </div>
                                    </div>
                                    <div className="HgtCheckBoxList">
                                        <div>
                                            <div className='dataAccessListItem'>
                                                <input type="checkbox"/>
                                                <p className="AllTextwithValue">
                                                    Select all <span>7</span>
                                                </p>
                                            </div>
                                            {/* {
                                                unselectedTempFiltered.map((item) => (
                                                    <DataAccessListItem isItDisabled={topLeftCheck || midLeftCheck} item={item} key={item.Id} selectItemHandler={selectItemHandler} type="ONE" />
                                                ))
                                            } */}
                                        </div>
                                    </div>
                                    {
                                            <div className="PaginationDiv" style={{ marginBottom: "5px", marginRight: "-6px" }}>
                                                <h5 className='PageNumbers'>
                                                   1
                                                </h5>
                                                <span>of</span>
                                                <h5 className='PageNumbers'>2</h5>
                                                <Pagination>
                                                    <Pagination.Prev />
                                                    <Pagination.Next/>
                                                </Pagination>
                                            </div>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="ButtonDiv">
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
    </>
  )
}

export default EditModalContainer